import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';

import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { Question } from '../../../../_models';
import { MinValidator } from 'src/app/_validators';

@Component({
  selector: 'app-question-type-essay',
  templateUrl: './question-type-essay.component.html',
  styleUrls: ['./question-type-essay.component.scss']
})
export class QuestionTypeEssayComponent implements OnInit {

  @Input('question') question: Question;
  @Input('formGroup') formGroup: FormGroup; settings: Settings;
  @Input('viewOnly') viewOnly = false;

  constructor(
    private fb: FormBuilder,
    public appSettings: AppSettings,
  ) {
    this.settings = this.appSettings.settings;
  }

  get maxChars() {
    return this.formGroup ? this.formGroup.get('maxChars') : null;
  }

  get rows() {
    return this.formGroup ? this.formGroup.get('rows') : null;
  }

  ngOnInit() {
    this.formGroup.addControl('maxChars',
      this.fb.control(this.question ? this.question.maxChars : '', [MinValidator.getMinValidator(1)]));

    this.formGroup.addControl('rows',
      this.fb.control(this.question ? this.question.rows : '', [MinValidator.getMinValidator(1)]));

    if (this.viewOnly)
      this.formGroup.disable();
  }

}
